import React, { useEffect, useRef } from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { ReactComponent as AllegrilIcon } from '../../assets/images/psp/allegril.svg';
import { Button } from '../UI-CHAKRA/Button';
import FreeSampleHeader from './FreeSampleHeader';

interface FreeSampleInterestSuccessStepProps {
  brand: string;
  medicineName: string;
  onClose: () => void;
  // Evento sample_request_completed (Amplitude): uma vez por exibição da confirmação.
  onRequestCompletedView: () => void;
}

// O Figma dessa tela específica (seção "Interesse") saiu sem o ícone de info nem o subtítulo do
// cabeçalho — inconsistência do design, não intencional. Mantemos o FreeSampleHeader padrão aqui
// também pra não quebrar o padrão visual do resto do fluxo.
const FreeSampleInterestSuccessStep: React.FC<FreeSampleInterestSuccessStepProps> = ({
  brand,
  medicineName,
  onClose,
  onRequestCompletedView,
}) => {
  const hasEmittedViewEventRef = useRef(false);

  useEffect(() => {
    if (hasEmittedViewEventRef.current) return;
    hasEmittedViewEventRef.current = true;
    onRequestCompletedView();
  }, [onRequestCompletedView]);

  return (
    <Flex flexDirection={'column'} height={'100%'} overflow="hidden">
      <FreeSampleHeader onClose={onClose} />

      <Box flexGrow={1} overflowY={'auto'} overflowX="hidden" padding={'20px'}>
        <Flex flexDirection={'column'} alignItems={'center'} justifyContent={'center'} gap={'16px'} padding={'20px 0'}>
          <AllegrilIcon width={'130px'} height={'130px'} />

          <Text fontSize={'26px'} fontWeight={700} color={'#343A40'} textAlign={'center'}>
            Interesse registrado
          </Text>

          <Text fontSize={'14px'} color={'#6C757D'} textAlign={'center'}>
            Encaminhamos seu interesse a {brand}, que define quais prescritores recebem amostras.
          </Text>
        </Flex>

        <Box mt={'20px'}>
          <Flex flexDirection={'row'} justifyContent={'space-between'} padding={'16px 0'}>
            <Text fontSize={'14px'} color={'#6C757D'}>
              Amostra
            </Text>
            <Text fontSize={'14px'} fontWeight={700} color={'#343A40'} textAlign={'right'} maxW={'56%'}>
              {brand} - {medicineName}
            </Text>
          </Flex>
        </Box>
      </Box>

      <Box flexShrink={0} padding={'20px'} borderTop={'1px solid #E9ECEF'}>
        <Flex flexDirection={'row'} gap={'12px'} justifyContent={'flex-end'}>
          <Button
            onClick={onClose}
            padding="10px 20px"
            backgroundColor={'#FFF'}
            borderWidth={'2px'}
            borderColor={'primary.main'}
            borderStyle={'solid'}
            borderRadius={'20px'}
            _hover={{ backgroundColor: '#FFF', borderColor: '#6B409C' }}
          >
            <Text fontSize={'14px'} color={'primary.main'}>
              Fechar
            </Text>
          </Button>
        </Flex>
      </Box>
    </Flex>
  );
};

export default FreeSampleInterestSuccessStep;
